import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core';
import { GoogleAnalyticsService } from './shared/services';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'homepage' }),
    NgbModule,
    AppRoutingModule,
    CoreModule,
  ],
  providers: [
    GoogleAnalyticsService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }

// Locale support
// import { registerLocaleData } from '@angular/common';
// import localeDe from '@angular/common/locales/de';
// import localeFr from '@angular/common/locales/fr';


// registerLocaleData(localeDe, 'de');
// registerLocaleData(localeFr, 'fr');
